import { Button, Input, Typography } from 'antd';
import React, { useState } from 'react';
import Sheet from 'react-modal-sheet';
import styles from './styles.module.css';

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: (rcNumber: string, ownerName: string) => void;
};

const AddVehicleSheet: React.FC<Props> = ({ open, onClose, onSubmit }) => {
  const [rc, setRc] = useState('');
  const [name, setName] = useState('');
  const valid = rc.trim().length >= 6 && name.trim().length >= 2;

  return (
    <Sheet
      isOpen={open}
      onClose={onClose}
      detent='content-height'
      disableScrollLocking
      style={{ zIndex: 100, maxWidth: 480, margin: 'auto' }}
    >
      <Sheet.Container>
        <Sheet.Header />
        <Sheet.Content>
          <div className={styles.addSheet}>
            <div>
              <div className={styles.addTitle}>Add a vehicle</div>
              <div className={styles.addSub}>
                We'll auto-fetch RC, insurance, PUC and challan info.
              </div>
            </div>

            <div>
              <Typography.Text style={{ fontSize: 12, color: '#6b7280' }}>
                Registration number
              </Typography.Text>
              <Input
                placeholder='e.g. GJ27EF6223'
                size='large'
                value={rc}
                maxLength={12}
                onChange={(e) =>
                  setRc(e.target.value.toUpperCase().replace(/\s/g, ''))
                }
                style={{ marginTop: 6, borderRadius: 12 }}
              />
            </div>

            <div>
              <Typography.Text style={{ fontSize: 12, color: '#6b7280' }}>
                Owner name (as per RC)
              </Typography.Text>
              <Input
                placeholder='Full name'
                size='large'
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={{ marginTop: 6, borderRadius: 12 }}
              />
            </div>

            <Typography.Text style={{ fontSize: 11, color: '#9ca3af' }}>
              By continuing, you consent to fetch RC details from VAHAN. Your
              data is encrypted and visible only to you.
            </Typography.Text>

            <Button
              className={styles.addBtn}
              disabled={!valid}
              onClick={() => onSubmit(rc.trim(), name.trim())}
              style={{ width: '100%', height: 44 }}
            >
              Verify &amp; Add
            </Button>
          </div>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop onTap={onClose} />
    </Sheet>
  );
};

export default AddVehicleSheet;
